import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class FeatureFlagService {
  private useNewJobTemplateVersion$ = new BehaviorSubject<boolean>(false);

  constructor() {}
  isFeatureEnabled() {
    return this.useNewJobTemplateVersion$.asObservable();
  }

  setFeatureFlag(enabled: boolean) {
    this.useNewJobTemplateVersion$.next(enabled);
  }
}
